import { Controller } from "@hotwired/stimulus"

// Per row: scheduled vs pre-bid vs LIVE from four server epochs + browser clock.
// Pre-bid sale: closing_ends_at !== ending_at. Pre-bid badge while starting_at <= now < closing_ends_at.
// LIVE when webcast_starts_at is present and browser time is at/after it; otherwise LIVE when past
// starting_at and not in the pre-bid window.
export default class extends Controller {
  static values = {
    startingAt: Number,
    endingAt: Number,
    closingEndsAt: Number,
    webcastStartsAt: Number,
  }

  static targets = ["scheduledTime", "prebid", "live"]

  connect() {
    this.sync()
    // Sync every 60 seconds
    this.timer = window.setInterval(() => this.sync(), 60_000)
  }

  disconnect() {
    if (this.timer) window.clearInterval(this.timer)
  }

  sync() {
    if (!Number.isFinite(this.startingAtValue)) return

    const nowSec = Date.now() / 1000
    const mode = this.#modeFor(nowSec)

    this.scheduledTimeTarget.hidden = mode !== "scheduled"
    this.prebidTargets.forEach((el) => {
      el.hidden = mode !== "prebid"
    })
    this.liveTargets.forEach((el) => {
      el.hidden = mode !== "live"
    })
  }

  #modeFor(nowSec) {
    if (this.#isLive(nowSec)) return "live"
    if (this.#inPrebid(nowSec)) return "prebid"
    return "scheduled"
  }

  #prebidSale() {
    if (!this.hasEndingAtValue || !this.hasClosingEndsAtValue) return false
    if (!Number.isFinite(this.endingAtValue) || !Number.isFinite(this.closingEndsAtValue)) return false
    return this.closingEndsAtValue !== this.endingAtValue
  }

  #inPrebid(nowSec) {
    if (!this.#prebidSale()) return false
    if (!this.hasClosingEndsAtValue || !Number.isFinite(this.closingEndsAtValue)) return false
    return nowSec >= this.startingAtValue && nowSec < this.closingEndsAtValue
  }

  #isLive(nowSec) {
    if (this.hasWebcastStartsAtValue && Number.isFinite(this.webcastStartsAtValue)) {
      return nowSec >= this.webcastStartsAtValue
    }
    return nowSec >= this.startingAtValue && !this.#inPrebid(nowSec)
  }
}
